import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Dashboard from '../pages/Dashboard';
import UserManagement from '../pages/User/UserManagement';
import PermissionList from '../pages/Permission/PermissionList';
import RoleList from '../pages/Role/RoleList';
import Login from '../pages/Login';
import AdminUserManagement from '../pages/System/AdminUserManagement';
import Settings from '../pages/Settings';
import AnalyticsDataPage from '../pages/Analytics/AnalyticsDataPage';
import AIConfigPage from '../pages/AIManagement/AIConfigPage';
import AIConnectivityTestPage from '../pages/AIManagement/AIConnectivityTestPage';
import PolarisImageTestPage from '../pages/AIManagement/PolarisImageTestPage';
import AICostMonitorPage from '../pages/AIManagement/AICostMonitorPage';
import CharacterNameLibraryPage from '../pages/AIManagement/CharacterNameLibraryPage';
import StorageConfigPage from '../pages/Storage/StorageConfigPage';
import ContentStudioConfigPage from '../pages/ContentStudio/ContentStudioConfigPage';
import ResourceListPage from '../pages/Storage/ResourceListPage';
import ResourcePullPage from '../pages/ResourcePull/ResourcePullPage';
import PaymentManagementPage from '../pages/PaymentManagement/PaymentManagementPage';
import RefundManagementPage from '../pages/Finance/RefundManagementPage';
import InitializationPage from '../pages/Initialization/InitializationPage';
import DataReportingPage from '../pages/DataReporting/DataReportingPage';
import LumingReportingPage from '../pages/LumingReporting/LumingReportingPage';
import AuthorManagementPage from '../pages/Authors/AuthorManagementPage';
import {
  BookCatalogAdminPage,
  CampaignAdminPage,
  InkAccountPage,
  InkRecordPage,
  InkTransferPage,
  LibrarySectionAdminPage,
  LibraryCategoryAdminPage,
  LibraryRankingAdminPage,
  OperationOverviewPage,
  OrderManagementPage,
  SiteNewsAdminPage,
  BookshelfAdminPage,
  WorkflowMonitorPage,
} from '../pages/Operations/OperationAdminPages';

const AppRoutes: React.FC = () => {
  // 检查登录状态
  const isAuthenticated = !!localStorage.getItem('token');

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="initialization" element={<InitializationPage />} />
        <Route path="data-reporting" element={<DataReportingPage />} />
        <Route path="luming-reporting" element={<LumingReportingPage />} />
        <Route path="analytics/events" element={<AnalyticsDataPage />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="permissions" element={<PermissionList />} />
        <Route path="roles" element={<RoleList />} />
        <Route path="system/admins" element={<AdminUserManagement />} />
        <Route path="settings" element={<Settings />} />
        <Route path="operations/overview" element={<OperationOverviewPage />} />
        <Route path="operations/orders" element={<OrderManagementPage />} />
        <Route path="operations/campaigns" element={<CampaignAdminPage />} />
        <Route path="operations/ink" element={<Navigate to="/ink/accounts" replace />} />
        <Route path="ink/accounts" element={<InkAccountPage />} />
        <Route path="ink/transfers" element={<InkTransferPage />} />
        <Route path="ink/records" element={<InkRecordPage />} />
        <Route path="creation/workflows" element={<WorkflowMonitorPage />} />
        <Route path="content/books" element={<BookCatalogAdminPage />} />
        <Route path="content/authors" element={<AuthorManagementPage />} />
        <Route path="content/sections" element={<LibrarySectionAdminPage />} />
        <Route path="content/categories" element={<LibraryCategoryAdminPage />} />
        <Route path="content/rankings" element={<LibraryRankingAdminPage />} />
        <Route path="content/news" element={<SiteNewsAdminPage />} />
        <Route path="content/bookshelves" element={<BookshelfAdminPage />} />
        <Route path="resource/list" element={<ResourceListPage />} />
        <Route path="resource/pull" element={<ResourcePullPage />} />
        <Route path="resource/storage" element={<StorageConfigPage />} />
        <Route path="payment-management" element={<PaymentManagementPage />} />
        <Route path="finance/refunds" element={<RefundManagementPage />} />
        <Route path="system/content-studio" element={<ContentStudioConfigPage />} />
        <Route path="system/storage" element={<Navigate to="/resource/storage" replace />} />
        <Route path="ai-management/config" element={<AIConfigPage />} />
        <Route path="ai-management/character-names" element={<CharacterNameLibraryPage />} />
        <Route path="ai-management/test" element={<Navigate to="/ai-tests/original" replace />} />
        <Route path="ai-tests/original" element={<AIConnectivityTestPage />} />
        <Route path="ai-tests/frw" element={<Navigate to="/ai-tests/image-generation" replace />} />
        <Route path="ai-tests/image-generation" element={<PolarisImageTestPage />} />
        <Route path="ai-management/costs" element={<AICostMonitorPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
      <Route path="/login" element={<Login />} />
    </Routes>
  );
};

export default AppRoutes;
